import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchServices = async () => {
  const { data } = await axios.get(`${API}/services`);
  return data;
};

export const fetchAvailability = async (date) => {
  const { data } = await axios.get(`${API}/bookings/availability`, { params: { date } });
  return data;
};

export const createBooking = async (payload) => {
  const { data } = await axios.post(`${API}/bookings`, payload);
  return data;
};
